import {Model, ICurrency, INumber, IDate} from '@ab/components';
import parser from '../parsers/main.m.p';

export default class extends Model {
    static parsers = {
        read: parser,
    };

    static fields = {
        ccyB: {
            fieldConstructor: ICurrency,
        },
        ccyA: {
            fieldConstructor: ICurrency,
        },
        rateB: {
            value: 0,
            fieldConstructor: INumber,
        },
        rateA: {
            value: 0,
            fieldConstructor: INumber,
        },

        // обратный курс, например USD-UAH = 0.0425 (0.0425 USD за 1 UAH)
        // обратный будет 1/0.0425 = 23.5 (23.5 UAH за 1 USD)
        rateC: {
            value: 0,
            fieldConstructor: INumber,
        },
        prevRateB: {
            value: 0,
            fieldConstructor: INumber,
        },
        prevRateA: {
            value: 0,
            fieldConstructor: INumber,
        },
        date: {
            fieldConstructor: IDate,
        },
    };

    rateB() {
        return new INumber(this.get('rateB').toFloat() / this.get('rateA').toFloat());
    }

    isProcessing() {
        return this.type === 'processing';
    }

    isNBU() {
        return this.type === 'nbu';
    }

    isBranches() {
        return this.type === 'branches';
    }
}
